import { Directive, TemplateRef, ViewContainerRef, Input, OnDestroy } from "@angular/core";
import { AuthService } from "./services/auth.service";
import { User } from "../models/user.model";
import { Subscription } from "rxjs";
import * as _ from 'lodash';
import { isArray } from "util";
import { forEach } from "@angular/router/src/utils/collection";


@Directive ({
  selector: "[rbacAllow]"
})
export class RbacAllowDirective implements OnDestroy {
  allowedRolls:string[];
  user:User;
  sub:Subscription

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private authService: AuthService ) {
    this.viewContainer.clear();
    this.sub = authService.user$.subscribe(
              user => {
                this.user = user;
                this.showIfUserAllowed();
              }
            )
  }

  @Input()
  set rbacAllow(allowedRoles: string[]) {
    this.allowedRolls = allowedRoles;
    this.showIfUserAllowed();
  }
  
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  showIfUserAllowed() {
    this.viewContainer.clear();
    if(!this.allowedRolls || this.allowedRolls.length === 0 || !this.user){
      this.viewContainer.clear();
      return;
    }
    //this.user.roles = ["userlgl","admin"]
     const isUserAllowed =  _.intersection(this.allowedRolls, this.user.roles).length > 0;

     if(isUserAllowed) {
       this.viewContainer.createEmbeddedView(this.templateRef);
     }else {
       this.viewContainer.clear();
     }
  }


}


// WEBPACK FOOTER //
// ./src/app/rbac-allow.directive.ts